import { Component } from '@angular/core';

@Component({
    selector: 'app-manual-prompt',
    templateUrl: './manual-prompt.component.html',
    styleUrls: ['./manual-prompt.component.css'],
    standalone: false
})
export class ManualPromptComponent {

}
